import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import * as moment from 'moment'


@Component({
  selector: 'app-circular',
  templateUrl: './circular.component.html',
  styleUrls: ['./circular.component.css']
})
export class CircularComponent implements OnInit {

  ClassList: any;
  Submitted: boolean = false;
  CircularList: any;
  SelectedFileForUpload: any;
  dropdownSettings: any = {};
  selectedItems: any = [];

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  CircularModel = {
    CircularID: 0,
    BranchID:0,
    Title: '',
    Description: '',
    CircularDate: '',
    PublishDate: '',
    ExpiryDate: '',
    IsActive: true,
    ClassIDs: '',
    ClassArray: [],
  };

  Clear() {

    this.CircularModel.CircularID = 0;
    this.CircularModel.BranchID=0;
    this.CircularModel.Title = '';
    this.CircularModel.CircularDate = '';
    this.CircularModel.PublishDate = '';
    this.CircularModel.ExpiryDate = '';
    this.CircularModel.Description = '';
    this.CircularModel.ClassArray = [];
    this.Submitted = false;
  };


  GetAllCircular() {
    this.spinnerService.show();
    this.adminservice.GetAllCircular().subscribe((response: any) => {
      this.CircularList = response.CircularList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };

  ValidState(){
    return this.globalHelper.GetLoginToken().UserTypeID==7 && this.CircularModel.BranchID==0;
  }

  SaveCircular(valid) {
    this.Submitted = true;
    var ClassID = '';

    for (var j = 0; j < this.CircularModel.ClassArray.length; j++) {
      if (ClassID == '') {
        ClassID = this.CircularModel.ClassArray[j].ItemId;
      }
      else {
        ClassID = ClassID + "," + this.CircularModel.ClassArray[j].ItemId;
      }
    }

    this.CircularModel.ClassIDs = ClassID;
    if (valid && !this.ValidState()) {
      this.spinnerService.show();
      this.CircularModel.CircularDate = this.CircularModel.CircularDate != null && this.CircularModel.CircularDate != '' ? moment(this.CircularModel.CircularDate).format('DD-MMM-YYYY') : '';
      this.CircularModel.PublishDate = this.CircularModel.PublishDate != null && this.CircularModel.PublishDate != '' ? moment(this.CircularModel.PublishDate).format('DD-MMM-YYYY') : '';
      this.CircularModel.ExpiryDate = this.CircularModel.ExpiryDate != null && this.CircularModel.ExpiryDate != '' ? moment(this.CircularModel.ExpiryDate).format('DD-MMM-YYYY') : '';
      this.adminservice.SaveCircular(JSON.stringify(this.CircularModel), this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.CircularModel.CircularID == 0) {
          this.Clear();
        }
        this.GetAllCircular();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  Edit(obj) {

    this.selectedItems = [];

    var ClassIDs = obj.ClassIDs != null ? obj.ClassIDs.split(',') : '';
    for (var i = 0; i < this.ClassList.length; i++) {
      for (var j = 0; j < ClassIDs.length; j++) {
        if (ClassIDs[j] == this.ClassList[i].ItemId) {
          let item = {
            ItemId: this.ClassList[i].ItemId,
            ItemName: this.ClassList[i].ItemName
          }
          this.selectedItems.push(item)
          break;
        }
      }
    }


    this.CircularModel.ClassArray = this.selectedItems;
    this.CircularModel.CircularID = obj.CircularID;
    this.CircularModel.Title = obj.Title;
    this.CircularModel.Description = obj.Description;
    this.CircularModel.CircularDate = moment(obj.CircularDate).format('DD-MMM-YYYY');
    this.CircularModel.PublishDate = obj.PublishDate != null ? moment(obj.PublishDate).format('DD-MMM-YYYY') : '';
    this.CircularModel.ExpiryDate = obj.ExpiryDate != null ? moment(obj.ExpiryDate).format('DD-MMM-YYYY') : '';
    this.CircularModel.IsActive = obj.IsActive;

  };


  CircularMarkActive(obj) {
    this.Clear();
    this.CircularModel.CircularID = obj.CircularID;
    this.CircularModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.adminservice.CircularMarkActive(JSON.stringify(this.CircularModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllCircular();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.BindClass();
    this.GetAllCircular();



  }


 
  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
      this.ClassList.splice(0, 1)
    });
  };



}




